import baseAxios, { type AxiosRequestConfig } from 'axios';

import { getMockedApiResponse } from 'src/mocks';

const api = baseAxios.create({
  baseURL: `${window.API_URL}/`,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV === 'development' && window.ENABLE_MOCKED_API) {
      const { method = 'get', url = '' } = error.config ?? {};
      const mockedResponse = getMockedApiResponse({ method, url });
      if (mockedResponse) {
        return Promise.resolve(mockedResponse);
      }
    }
    return Promise.reject(error);
  }
);

export const doGet = <T = any>(url: string, options?: AxiosRequestConfig) => {
  const filter = options?.params?.filter ? JSON.stringify(options?.params?.filter) : undefined;
  return api.get<T>(url, { ...options, params: { ...options?.params, filter } });
};

export const doPost = <T = any, P = any>(url: string, data?: P, options?: AxiosRequestConfig) =>
  api.post<T>(url, data, options);

export const doPatch = <T = any, P = any>(url: string, data?: P, options?: AxiosRequestConfig) =>
  api.patch<T>(url, data, options);

export const doPut = <T = any, P = any>(url: string, data: P, options?: AxiosRequestConfig) =>
  api.put<T>(url, data, options);

export const doDelete = <T = any>(url: string, options?: AxiosRequestConfig) =>
  api.delete<T>(url, options);
